import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from "react-toastify";
import { getDeviceDetails, deleteDevice, searchDeviceMgmt } from "../Actions/DeviceManagement";
import Role from "../helpers/role";

const SearchItem = {
  id: "",
  make: "",
  model: "",
  manufacturingDate: "",
  lastCalibrationDate: "",
  nextCalibrationDate: "",
  companyName: "",
  shipName: "",
  pageNumber: 1,
  pageSize: 25,
};

let userRole = localStorage.getItem("UserRoles");

class DeviceManagementDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      searchData: {
        deviceId: '',
        make: '',
        modal: '',
        manufacturingDate: '',
        lastCalibrationDate: '',
        nextCalibrationDate: '',
        companyName: '',
        shipName: '',
        pageNumber: 1,
        pageSize: 25
      }
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getDeviceDetails(id));
  }
  componentDidUpdate() {
    const { dispatch, match } = this.props;
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.setState({ showSidePane: false });

      //   this.props.history.push("/Home/Management/Device");
    };
  }
  ShowSidePanel = () => {
    this.setState({ showSidePane: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Device");
  };

  render() {
    const { DeviceDetails } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row pt-4 pb-3"> </div>
          <div className="row pt-3">
            <div className="col-lg-12">
              <div className="resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.ShowSidePanel()}
                  >
                    <div style={{ position: 'relative' }}>
                      <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                    </div>
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title m-2"
                        style={{ color: "092a51" }}
                      >
                        Device Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6">
                          <label className="form-label">ID :</label>
                          <span>
                            {" "}
                            {DeviceDetails ? DeviceDetails.id : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Make :</label>
                          <span>
                            {" "}
                            {DeviceDetails ? DeviceDetails.make : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Modal :</label>
                          <span>
                            {" "}
                            {DeviceDetails ? DeviceDetails.model : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">
                            Manufacturing Date :
                          </label>
                          <span>
                            {" "}
                            {DeviceDetails
                              ? moment(DeviceDetails.manufacturingDate).format(
                                "DD MMM YYYY"
                              )
                              : ""}
                          </span>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                            Last Calibration Date :
                          </label>
                          <span>
                            {" "}
                            {DeviceDetails
                              ? moment(
                                DeviceDetails.lastCalibrationDate
                              ).format("DD MMM YYYY")
                              : ""}
                          </span>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                            Next Calibration Date :
                          </label>
                          <span>
                            {" "}
                            {DeviceDetails
                              ? moment(
                                DeviceDetails.nextCalibrationDate
                              ).format("DD MMM YYYY")
                              : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Company Name :</label>
                          <span>
                            {" "}
                            {DeviceDetails ? DeviceDetails.companyName : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Ship Name :</label>
                          <span>
                            {" "}
                            {DeviceDetails ? DeviceDetails.shipName : ""}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Maximum Limit :</label>
                          <span>
                            {" "}
                            {DeviceDetails.maximumLimit !== 0 ? DeviceDetails.maximumLimit : 0}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <label className="form-label">Is Active :</label>
                          <span>
                            {" "}
                            {DeviceDetails.isActive == true ? "Yes" : DeviceDetails.isActive == false ? "No" : "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        {userRole == Role.mmpl ? (<>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ShowSidePanel()}
                          >
                            {" "}
                            Cancel{" "}
                          </button>
                        </>) : (<>
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.EditDeviceDetails(DeviceDetails)}
                          >
                            {" "}
                            Edit{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() =>
                              this.DeleteDeviceDetails(DeviceDetails)
                            }
                          >
                            {" "}
                            Delete{" "}
                          </button>
                        </>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  EditDeviceDetails(item) {
    const { dispatch, history } = this.props;
    history.push(`/Home/Management/DeviceEdit/${item.deviceId}`);
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "ShipcompanyName", data: item.companyName });
  }

  DeleteDeviceDetails(item) {
    const { dispatch } = this.props;
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let deviceinfo = {
              id: item.id,
              deviceId: item.deviceId,
              make: item.make,
              model: item.model,
              manufacturingDate: item.manufacturingDate,
              lastCalibrationDate: item.lastCalibrationDate,
              companyName: item.companyName,
              shipName: item.shipName,
              maximumLimit: item.maximumLimit,
              modifiedBy: "",
              isDeleted: true,
            };
            dispatch(deleteDevice(deviceinfo, this.state.searchData));
            dispatch(searchDeviceMgmt(SearchItem));
            this.ShowSidePanel();
            toast.success("Deleted Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
      overlayClassName: 'custom-alert',
    });
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    DeviceDetails: state.DeviceManagementReducer.DeviceDetails,
    //    DeviceDetails:{deviceId:"1",
    //    shipName:"Ship 1",
    //    companyName:"AZ",
    //    manufacturingDate:"2020-12-29T12:55:23.97",
    //    make:"Test",
    //    modal:"User",
    //    nextCalibrationDate:"2021-03-29T12:55:23.97",
    //    lastCalibrationDate:"2020-12-29T12:55:23.97"
    //    }
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DeviceManagementDetail)
);
